import { exists } from './exists'

/**
 * 検査対象が存在するかどうかをチェックし、存在しない場合は例外を投げます。
 *
 * @template T - 検査対象の型。
 * @param value - 検査対象。
 * @param message - 例外時のメッセージ。
 * @throws 検査対象が存在しない場合。
 */
export function assertExists<T>(
  value: T | null | undefined,
  message = 'アサーションに失敗しました',
): asserts value is T {
  if (!exists(value)) {
    throw new Error(message)
  }
}
